

import axiosInst from '@/utility/axiosInst'

export default {
  requestCreateWeddingInvitation({}, payload) {
    return axiosInst.springAxiosInst.post("/wedding/create-wedding", payload)
      .then((res) => {
        return res.data
      })
  },

  requestWeddingInvitationForEdit({}, weddingInvitationSeq) {
    return axiosInst.springAxiosInst.get("/wedding/get-wedding-for-edit", {
      params: {
        weddingInvitationSeq: weddingInvitationSeq
      }
    }).then((res) => {
      return res.data
    })
  },

  requestWeddingInvitationEdit({}, payload){
    return axiosInst.springAxiosInst.post('/wedding/edit-wedding', payload).then(res => {
      return res.data
    })
  } 
}